exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-select{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);

// exports
